import {DateRange} from '@/dateUtils/DateRange'
import {computed, Ref} from 'vue'
import {DateRangeMatrix} from '@/dateUtils/v2/DateRangeMatrix'
import {ensureUTC} from '@/dateUtils/v2/DateRange.util'

export const useTermMatrix = (range: Ref<DateRange>, isDisabled?: (range: DateRange) => boolean) => {
    ensureUTC(range)

    const getStartMonth = (term: number): number => (term - 1) * 2
    const getEndMonth = (term: number): number => getStartMonth(term) + 2

    const getTermRange = (year: number, term: number): DateRange => ({
        start: new Date(Date.UTC(year, getStartMonth(term), 1)),
        end: new Date(Date.UTC(year, getEndMonth(term), 0))
    })

    const isTermSelected = (term: number): boolean => {
        if (range.value.start.getFullYear() !== range.value.end.getFullYear()) return false
        const {start, end} = getTermRange(range.value.start.getFullYear(), term)
        return range.value.start <= start && end <= range.value.end
    }

    const selectTerm = (term: number) => {
        range.value = getTermRange(range.value.start.getFullYear(), term)
    }

    const terms = computed<DateRangeMatrix[]>(() => {
        const selectedYear = range.value.start.getFullYear()

        return [1, 2, 3, 4, 5, 6].map(term => {
            const range = getTermRange(selectedYear, term)
            return {
                value: term,
                label: `T${term}`,
                selected: isTermSelected(term),
                disabled: !!isDisabled && isDisabled(range),
                onClick: () => selectTerm(term),
                range: range
            } as DateRangeMatrix
        })
    })

    return {
        range,
        terms
    }
}